import {CONTRIBUTORS} from 'data/CONTRIBUTORS'

export const changelog = [
	// {
	// 	date: new Date('2021-11-19'),
	// 	Changes: () => <>The changes you made</>,
	// 	contributors: [CONTRIBUTORS.YOU],
	// },
	{
		date: new Date('2026-04-18'),
		Changes: () => <>Updated Kunai's Bane window tracking to stop penalizing uses of Goka Mekkyaku.</>,
		contributors: [CONTRIBUTORS.TOASTDEIB],
	},
	{
		date: new Date('2025-08-06'),
		Changes: () => <>Updated Hellfrog/Deathfrog Medium tracking for the 7.3 potency changes.</>,
		contributors: [CONTRIBUTORS.TOASTDEIB],
	},
	{
		date: new Date('2025-04-05'),
		Changes: () => <>Corrected Deathfrog Medium tracking to expect three or more targets instead of two or more.</>,
		contributors: [CONTRIBUTORS.TOASTDEIB],
	},
	{
		date: new Date('2024-08-02'),
		Changes: () => <>Added Dokumori to the raid buffs list on the timeline.</>,
		contributors: [CONTRIBUTORS.TOASTDEIB],
	},
	{
		date: new Date('2024-07-17'),
		Changes: () => <>Added a module for tracking dropped Phantom Kamaitachi Ready and Tenri Jindo Ready procs.</>,
		contributors: [CONTRIBUTORS.TOASTDEIB],
	},
	{
		date: new Date('2024-07-12'),
		Changes: () => <>Fixed a bug with Kunai's Bane not always registering the last attack in a window.</>,
		contributors: [CONTRIBUTORS.TOASTDEIB],
	},
	{
		date: new Date('2024-07-12'),
		Changes: () => <>Updated Kazematoi suggestion tiers.</>,
		contributors: [CONTRIBUTORS.TOASTDEIB],
	},
	{
		date: new Date('2024-06-10'),
		Changes: () => <>Initial NIN support for Dawntrail.</>,
		contributors: [CONTRIBUTORS.TOASTDEIB],
	},
]
